import {useTranslation} from 'react-i18next'

import {Modal} from '../../../../../_metronic/elements/Modal'
import {KTSVG} from '../../../../../_metronic/helpers'

export const PlanetHdImpactNotice = ({action}) => {
  const {t} = useTranslation()

  return (
    <div className='alert alert-warning mb-0' role='alert'>
      <h5 className='mb-2'>{t('lands:planet_hd_warning.title')}</h5>
      <p className='mb-3'>{t(`lands:planet_hd_warning.${action}.message`)}</p>
      <p className='mb-0'>{t(`lands:planet_hd_warning.${action}.credits`)}</p>
    </div>
  )
}

export const PlanetHdAccessCheck = ({status, onRetry}) => {
  const {t} = useTranslation()

  if (status === 'checking') {
    return (
      <div className='d-flex align-items-center gap-3 text-muted' role='status'>
        <span className='spinner-border spinner-border-sm' aria-hidden='true' />
        <span>{t('lands:planet_hd_warning.checking')}</span>
      </div>
    )
  }

  if (status !== 'error') {
    return null
  }

  return (
    <div className='alert alert-danger mb-0' role='alert'>
      <p className='mb-3'>{t('lands:planet_hd_warning.check_error')}</p>
      <button type='button' className='btn btn-sm btn-light-danger' onClick={onRetry}>
        {t('lands:planet_hd_warning.retry')}
      </button>
    </div>
  )
}

const PlanetHdPerimeterConfirmModal = ({open, onCancel, onConfirm}) => {
  const {t} = useTranslation()

  return (
    <Modal
      open={open}
      setOpen={(nextOpen) => {
        if (!nextOpen) {
          onCancel()
        }
      }}
    >
      <div className='modal-dialog modal-dialog-centered'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>{t('lands:planet_hd_warning.perimeter.title')}</h5>
            <button
              type='button'
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              onClick={onCancel}
              aria-label={t('common:actions.close', {defaultValue: 'Cerrar'})}
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </button>
          </div>
          <div className='modal-body'>
            <PlanetHdImpactNotice action='perimeter' />
          </div>
          <div className='modal-footer'>
            <button type='button' className='btn btn-light' onClick={onCancel}>
              {t('lands:planet_hd_warning.buttons.cancel')}
            </button>
            <button type='button' className='btn btn-primary' onClick={onConfirm}>
              {t('lands:planet_hd_warning.buttons.continue')}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default PlanetHdPerimeterConfirmModal
